<app-dialog #dialog
            [showQuickCancelButton]="true"
            (cancel)="cancelButtonClicked()"
            cancelButtonText="Cancel"
            [title]="data.title">
  <p><small>{{data.subtitle}}</small></p>
  <p [innerText]="data.note"></p>
</app-dialog>
